export const fields = [
  {
    attr: 'name',
    name: '分类名称',
    value: '',
    type: 'Input',
    props: {
      placeholder: '请输入分类名称',
      rules: {
        required: true,
        message: '请输入分类名称',
        target: 'blur'
      }
    },
    options: []
  },
  // {
  //   attr: 'description',
  //   name: '分类描述',
  //   value: '',
  //   type: 'Input',
  //   props: {
  //     placeholder: '请输入分类描述',
  //     rules: {
  //       required: false,
  //       message: '请输入分类描述',
  //       target: 'blur'
  //     },
  //     type: 'textarea',
  //     row: 2
  //   }
  // }
]



// WEBPACK FOOTER //
// ./src/views/components/typeSelect2/typeName/fields.js